import { createAction } from '@reduxjs/toolkit';
import { SET_FASLET_ORDER_TRACKING_DATA, SET_FASLET_SHOPPING_ID, SET_INITIAL_ORDER_TRACKING_DATA, SET_IS_WIDGET_SHOWN, SET_ITEM_ADDED_TO_CART, SET_FASLET_ANALYTIC_TRIGGER, } from './actionTypes';
export const setItemAddedToCart = createAction(SET_ITEM_ADDED_TO_CART);
export const setIsWidgetShown = createAction(SET_IS_WIDGET_SHOWN);
export const setFasletShoppingId = createAction(SET_FASLET_SHOPPING_ID);
export const setFasletAnalyticTrigger = createAction(SET_FASLET_ANALYTIC_TRIGGER);
export const setInitialOrderTrackingData = createAction(SET_INITIAL_ORDER_TRACKING_DATA);
export const setFasletOrderTrackingData = createAction(SET_FASLET_ORDER_TRACKING_DATA);
export const actions = {
    setItemAddedToCart,
    setIsWidgetShown,
    setFasletShoppingId,
    setFasletOrderTrackingData,
    setInitialOrderTrackingData,
    setFasletAnalyticTrigger,
};
